<template>
	<div class="foot-btn-simple">
       <div class="foot-btn-simple_btn_ext" v-if="btnExt" v-on:click="ext" v-bind:class=' isExton === true ? "foot-btn-simple_btn_ext_on" : "" '>{{btnExt}}</div>
       <div class="foot-btn-simple_btn" v-on:click="next" v-bind:class=' isOn===true ? "foot-btn-simple_btn_on" : "" '>{{btnTxt}}</div>
  </div>
</template>

<style lang='less'>
  @import 'foot-btn-simple.less';
</style>

<script type="text/javascript">
export default {
	name: 'foot-btn-simple',
	data() {
		return {}
	},
	props: {
		btnTxt: {
			type: String, //按钮文字
			default: ''
		},
		btnExt: {
			type: String, //按钮文字
			default: ''
		},
		isOn: {
			type: Boolean, //是否高亮
			default: false
		},
		isExton: {
			type: Boolean, // 扩展按钮是否高亮
			default: false
		},
	},
	methods: {
		next: function() {
			if (this.isOn) {
				this.$emit('next');
			}
		},
		ext: function() {
			if (this.isExton) {
				this.$emit('ext');
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// ../common-npm/flyme7/component/foot-btn-simple/foot-btn-simple.vue